<template>
    <div v-if="status === 'loaded'" id="tasks-list">
        <the-nav>
            <h1>Tareas</h1>

            <div class="buttons-container">
                <button class="btn btn-primary me-4"
                        @click="setQuickFilters(null, [user.id], null, null, ['Abierta', 'Agente asignado', 'En proceso de resolución'])">
                    Mis tareas abiertas
                </button>

                <button class="btn btn-primary me-4"
                        @click="setQuickFilters(null, null, [user.role.id], null, ['Abierta', 'Agente asignado', 'En proceso de resolución'])">
                    Tareas abiertas de mi equipo
                </button>

                <button class="btn btn-primary me-4"
                        @click="setQuickFilters(null, null, null, [user.id], ['Abierta', 'Agente asignado', 'En proceso de resolución'])">
                    Tareas abiertas que he creado
                </button>

                <button class="btn btn-danger me-4"
                        @click="emptyFilters(); doSearch()">
                    <span class="uq-icon bi-filter me-2"></span>
                    Limpiar filtros
                </button>

                <button class="btn btn-download icon-wrapper"
                        v-if="can('export.tasks')"
                        @click="downloadTasks(filters)">
                  <i class="uq-icon bi-download"></i>
                </button>

                <button class="btn btn-secondary" type="button" @click="this.modalToShow = 'add-task'"
                        title="Nuevo procurador" v-if="can('task.store')">
                    <span>Añadir tarea</span>
                </button>
            </div>
        </the-nav>

        <div class="row form-container mb-0">
            <div class="col-3 form-wrapper mb-0">
                <div class="form-group search-form">
                    <label class="form-label">Tipo:</label>

                    <v-multi-select-j-q id="selectType"
                                        ref="multiselectType"
                                        @update:value="filters.type = $event;"
                                        :options="availableTypes"
                                        parent-id="tasks-list"
                                        placeholder="- Seleccionar -"
                                        @change="search"
                                        :value="filters.type">
                        <option disabled value="0">Selecciona una opción</option>
                    </v-multi-select-j-q>
                </div>
            </div>

            <div class="col-3 form-wrapper mb-0">
                <div class="form-group search-form">
                    <label class="form-label">Equipo:</label>

                    <v-multi-select-j-q id="selectRole"
                                        ref="multiselectRole"
                                        @update:value="filters.role = $event;"
                                        :options="availableRoles"
                                        parent-id="tasks-list"
                                        placeholder="- Seleccionar -"
                                        @change="search"
                                        :value="filters.role">
                        <option disabled value="0">Selecciona una opción</option>
                    </v-multi-select-j-q>
                </div>
            </div>

            <div class="col-3 form-wrapper mb-0">
                <div class="form-group search-form">
                    <label class="form-label">Responsable:</label>

                    <v-multi-select-j-q id="selectResponsable"
                                        ref="multiselectResponsable"
                                        @update:value="filters.user = $event;"
                                        :options="availableUsers"
                                        parent-id="tasks-list"
                                        placeholder="- Seleccionar -"
                                        @change="search"
                                        :value="filters.user">
                        <option disabled value="0">Selecciona una opción</option>
                    </v-multi-select-j-q>
                </div>
            </div>

            <div class="col-3 form-wrapper mb-0">
                <div class="form-group search-form">
                    <label class="form-label">Autor:</label>

                    <v-multi-select-j-q id="selectAutor"
                                        ref="multiselectAutor"
                                        @update:value="filters.author = $event;"
                                        :options="availableUsers"
                                        parent-id="tasks-list"
                                        placeholder="- Seleccionar -"
                                        @change="search"
                                        :value="filters.author">
                        <option disabled value="0">Selecciona una opción</option>
                    </v-multi-select-j-q>
                </div>
            </div>
        </div>

        <div class="row form-container mb-0">
            <div class="col-4 form-wrapper mb-0">
                <div class="form-group search-form">
                    <label class="form-label">Cliente:</label>

                    <v-multi-select-j-q id="selectClients"
                                        ref="multiselectClients"
                                        @update:value="filters.client = $event;"
                                        :options="availableClients"
                                        parent-id="tasks-list"
                                        placeholder="- Seleccionar -"
                                        @change="search"
                                        :value="filters.client">
                        <option disabled value="0">Selecciona una opción</option>
                    </v-multi-select-j-q>
                </div>
            </div>

            <div class="col-3 form-wrapper mb-0">
                <div class="form-group search-form">
                    <label class="form-label">Estado:</label>

                    <v-multi-select-j-q id="selectStatus"
                                        ref="multiselectStatus"
                                        @update:value="filters.status = $event;"
                                        :options="availableStatus"
                                        parent-id="tasks-list"
                                        placeholder="- Seleccionar -"
                                        @change="search"
                                        :value="filters.status">
                        <option disabled value="0">Selecciona una opción</option>
                    </v-multi-select-j-q>
                </div>
            </div>

            <div class="col-3 form-wrapper mb-0">
                <div class="form-group search-form">
                    <label class="form-label">Orden:</label>

                    <select class="form-select dropdown-toggle"
                            v-model="filters.order"
                            @change="search"
                            :value="filters.order">
                        <option value="DESC">Más reciente primero</option>
                        <option value="ASC">Más antigua primero</option>
                        <option value="PRIOR">Más prioritarias primero</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="admin-main">
            <v-table :meta="tasks.meta" :pagination="tasks.links.pagination" @pageChanged="pageChanged">
                <template v-slot:header>
                    <th>Creada</th>
                    <th>Nombre</th>
                    <th>Tipo</th>
                    <th>Origen</th>
                    <th>Descripción</th>
                    <th>Estado</th>
                    <th>Responsable</th>
                    <th>Equipo</th>
                    <th>Cliente</th>
                    <th>Expediente</th>
                    <th>Fecha finalización</th>
                    <th>Autor</th>
                    <th class="fit">Acciones</th>
                </template>

                <template v-slot:body>
                    <div class="loader" v-if="tasks_loading"></div>
                    <template v-else>
                        <tr v-for="task in tasks.data" :key="task.id">
                            <td>{{ dateToReadable(task.created_at) }}</td>
                            <td>{{ task.name }}</td>
                            <td><span class="badge bg-dark">{{ task.type }}</span></td>
                            <td><span class="badge bg-info">{{ task.origin }}</span></td>
                            <td>
                                <v-popover class="clickable"
                                           title=""
                                           :content="!!task.description ? task.description : 'No hay descripción'">
                                    <div class="text-truncate-ellipsis">{{ task.description }}</div>
                                </v-popover>
                            </td>

                            <td class="clickable"
                                @click="editTaskStatus(task)"
                                v-if="can('task.change-status')">
                                <span
                                    class="badge"
                                    :class="{'bg-danger': task.status === 'Abierta', 'bg-warning': task.status === 'Agente asignado' || task.status === 'En proceso de resolución', 'bg-success': task.status === 'Cerrada' }"
                                >
                                    {{ task.status }}
                                </span>
                            </td>

                            <td v-else>
                                <span
                                    class="badge"
                                    :class="{'bg-danger': task.status === 'Abierta', 'bg-warning': task.status in ['Agente asignado', 'En proceso de resolución'], 'bg-success': task.status === 'Cerrada' }"
                                >
                                    {{ task.status }}
                                </span>
                            </td>
                            <td class="clickable"
                                @click="editTaskUser(task)"
                                v-if="can('task.update') && can('task.change-status')">
                                <span class="colorize-hover" v-if="!!task.user">{{ !!task.user ? task.user.name : '-' }}</span>
                                <span class="colorize-hover" v-else>Sin responsable</span>
                            </td>

                            <td v-else>
                                <span>{{ !!task.user ? task.user.name : '-' }}</span>
                            </td>

                            <td class="clickable"
                                @click="editTaskTeam(task)"
                                v-if="can('task.update')">
                                <span class="colorize-hover">{{ !!task.role ? formatRoleName(task.role.name) : '-' }}</span>
                            </td>

                            <td v-else>
                                <span>{{ !!task.role ? formatRoleName(task.role.name) : '-' }}</span>
                            </td>

                            <td class="clickable"
                                v-if="!!task.client"
                                @click="showClient(task.client)"
                            >
                                <span class="colorize-hover">{{ task.client.code }}</span>
                            </td>
                            <td v-else>
                                -
                            </td>

                            <td>
                                <span>{{ !!task.expedient ? task.expedient.name : '-' }}</span>
                            </td>

                            <td v-if="task.end_date">{{ dateToReadable(task.end_date) }}</td>
                            <td v-else>-</td>

                            <td>{{ formatRoleName(task.author.name) }}</td>
                            <td class="fit">
                                <div class="actions-container">
                                    <button class="btn btn-show" @click="showTask(task)"
                                            v-if="can('task.show')">
                                        <span class="uq-icon bi-eye"></span>
                                    </button>

                                    <button class="btn btn-edit" @click="editTask(task)"
                                            v-if="can('task.update')">
                                        <span class="uq-icon bi-pencil"></span>
                                    </button>

                                    <button class="btn btn-delete" @click="deleteTask(task)"
                                            v-if="can('task.destroy')">
                                        <span class="uq-icon bi-trash"></span>
                                    </button>

                                    <button class="btn btn-primary"
                                            @click="selectedTask = task; setResponsibleTask(user.id)"
                                            v-if="can('task.update')">
                                        Asignarme
                                    </button>
                                </div>
                            </td>
                        </tr>

                        <tr v-if="!tasks.data">
                            <td colspan="222222">No hay tareas</td>
                        </tr>
                    </template>
                </template>
            </v-table>

            <div v-if="status === 'loading'">
                <div class="loader-container">
                    <div class="loader"></div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="status === 'errorPermissions' && user.roleName !== 'Admin'">
        No tienes permisos
    </div>

    <clients-list-show-modal :client="selectedClient"
                             v-if="modalToShow === 'show-expedient-client'"
                             @closed="modalToShow = null; selectedClient = null;">
    </clients-list-show-modal>

    <tasks-list-show-modal :selected-task="selectedTask"
                           @closed="modalToShow = null;"
                           v-if="modalToShow === 'show-task'">
    </tasks-list-show-modal>

    <tasks-list-add-modal v-if="modalToShow === 'add-task'"
                          @closed="modalToShow = null; removeUrlQueryParameters(); filters.createTask = '';"
                          @task-created="loadTasks">
    </tasks-list-add-modal>

    <tasks-list-edit-modal :selected-task="selectedTask"
                           @task-updated="modalToShow = null; loadTasks()"
                           @closed="modalToShow = null; removeUrlQueryParameters(); filters.createTask = '';"
                           v-if="modalToShow === 'edit-task'">
    </tasks-list-edit-modal>

    <task-change-status-modal :task="selectedTask"
                              @task-status-updated="modalToShow = null; loadTasks()"
                              @closed="modalToShow = null;"
                              v-if="modalToShow === 'task-change-status-modal'">
    </task-change-status-modal>

    <task-change-user-modal :user="selectedTask.user_id"
                            @task-user-updated="setResponsibleTask"
                            @closed="modalToShow = null;"
                            v-if="modalToShow === 'task-change-user-modal'">
    </task-change-user-modal>

    <task-change-team-modal :task="selectedTask"
                            @task-team-updated="modalToShow = null; loadTasks()"
                            @closed="modalToShow = null;"
                            v-if="modalToShow === 'task-change-team-modal'">
    </task-change-team-modal>

    <tasks-list-show-modal :task="selectedTask"
                           @closed="modalToShow = null;"
                           v-if="modalToShow === 'task-list-show-modal'">

    </tasks-list-show-modal>

    <task-delete-modal :task="selectedTask"
                       @task-deleted="modalToShow = null; loadTasks()"
                       @closed="modalToShow = null"
                       v-if="modalToShow === 'task-delete-modal'">
    </task-delete-modal>
</template>

<script>
import {can} from "../../helpers/Permissions";
import TheNav from "../layouts/TheNav";
import VPagination from "../general/VPagination";
import VTable from "../general/VTable";
import TasksListAddModal from "./parts/TasksListAddModal";
import {createTask, getTasksPaginated, updateTask} from "../../helpers/requests/RequestsTasks";
import VSelectJq from "../general/VSelectJQ";
import VMultiSelectJQ from "../general/VMultiSelectJQ";
import {filtersToQueryParameters, setQueryParameters} from "../../helpers/Url";
import router from "../../router";
import {withTimeout} from "../../helpers/requests/RequestsCore";
import {getRoles} from "../../helpers/requests/RequestsRoles";
import {getUsers} from "../../helpers/requests/RequestsUsers";
import TasksListEditModal from "./parts/TasksListEditModal";
import TaskChangeStatusModal from "./parts/TaskChangeStatusModal";
import TaskChangeUserModal from "./parts/TaskChangeUserModal";
import TaskChangeTeamModal from "./parts/TaskChangeTeamModal";
import TaskDeleteModal from "./parts/TaskDeleteModal";
import VPopover from "../general/VPopover";
import TasksListShowModal from "./parts/TasksListShowModal";
import ClientsListShowModal from "../clients/parts/ClientsListShowModal";
import {getAllClientsWithoutPagination} from "../../helpers/requests/RequestsClients";
import {downloadTareasXLSX} from '../../helpers/Exports.js';

export default {
    name: "TasksList",
    components: {
        ClientsListShowModal,
        VPopover,
        TasksListShowModal,
        TaskDeleteModal,
        TaskChangeTeamModal,
        TaskChangeUserModal,
        TaskChangeStatusModal,
        TasksListEditModal,
        VMultiSelectJQ,
        VSelectJq,
        TasksListAddModal,
        VPagination,
        TheNav,
        VTable
    },
    setup() {
        return {
            can,
        }
    },
    data() {
        return {
            status: 'loading',
            tasks_loading: true,

            tasks: [],
            task: null,
            selectedTask: null,
            modalToShow: null,

            availableRoles: [],
            availableUsers: [],
            availableTypes: [
                {id: 'Incidencia', text: 'Incidencia'},
                {id: 'Tarea global', text: 'Tarea global'},
                {id: 'Tarea interna', text: 'Tarea interna'},
                {id: 'Otras tareas', text: 'Otras tareas'},
            ],
            availableStatus: [
                {id: 'Abierta', text: 'Abierta'},
                {id: 'Agente asignado', text: 'Agente asignado'},
                {id: 'En proceso de resolución', text: 'En proceso de resolución'},
                {id: 'Cerrada', text: 'Cerrada'},
            ],

            do_search: true,

            selectedClient: null,

            filters: {
                type: [],
                role: [],
                author: [],
                client: [],
                status: [],
                user: [],
                order: 'DESC',
                page: 1,
            },
            timers: {
                search: '',
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user.userLogged;
        }
    },
    async mounted() {
        window.$ = window.jQuery = require('jquery');

        await Promise.all([
            this.loadAvailableRoles(),
            this.loadAvailableUsers(),
            this.loadAvailableClients(),
        ]);

        // Read query params to form filters
        await this.setQueryParametersAsFilters();
        await this.doSearch();
        this.status = 'loaded';
    },
    watch: {
        $route(to, from) {
            // Apply only if we are operating over the same view
            if (to.name === from.name) {
                // TODO: Watch this and just only change url query parameters when methods fire something? This will do the rest
                this.setQueryParametersAsFilters();

                // We force it to not search because of a two-requests problem
                if (this.do_search === true) {
                    this.doSearch();
                }

                this.do_search = true;
            }
        }
    },
    methods: {
      downloadTasks(filters) {
        this.$store.dispatch('app/setToastMessage', 'Procesando la descarga...');
        downloadTareasXLSX(filters);
      },
        formatRoleName(name) {
            return name.charAt(0).toUpperCase() + name.slice(1).replaceAll('_', ' ');
        },
        async doSearch() {
            this.do_search = false;

            await this.setFiltersAsQueryParameters();
            await this.loadTasks();
        },
        emptyFilters() {
            this.filters = {
                type: [],
                role: [],
                user: [],
                client: [],
                author: [],
                status: [],
                order: 'DESC',
                page: 1,
            };

            // FIXME: Limpiar etiquetas sin tener que llamar al metodo de VMultiSelectJQ
            this.$refs.multiselectType.removeAll();
            this.$refs.multiselectRole.removeAll();
            this.$refs.multiselectResponsable.removeAll();
            this.$refs.multiselectAutor.removeAll();
            this.$refs.multiselectClients.removeAll();
            this.$refs.multiselectStatus.removeAll();
        },
        /**
         * Detects any query parameter in the url and loads it in the filters (if available)
         *
         * @returns {Promise<void>}
         */
        async setQueryParametersAsFilters() {
            let query_parameters = router.currentRoute.value.query;

            if (query_parameters.type) {
                this.filters.type = query_parameters.type;
            } else {
                this.filters.type = [];
            }

            if (query_parameters.role) {
                this.filters.role = query_parameters.role;
            } else {
                this.filters.role = [];
            }

            if (query_parameters.author) {
                this.filters.author = query_parameters.author;
            } else {
                this.filters.author = [];
            }

            if (query_parameters.client) {
                this.filters.client = query_parameters.client;
            } else {
                this.filters.client = [];
            }

            if (query_parameters.status) {
                this.filters.status = query_parameters.status;
            } else {
                this.filters.status = [];
            }

            if (query_parameters.user) {
                this.filters.user = query_parameters.user;
            } else {
                this.filters.user = [];
            }

            if (query_parameters.order) {
                this.filters.order = query_parameters.order;
            } else {
                this.filters.order = 'DESC';
            }

            // Create new task
            if (query_parameters.createTask === 'true') {
                this.filters.createTask = query_parameters.createTask;
                this.modalToShow = 'add-task';
            } else {
                this.filters.createTask = '';
                this.modalToShow = '';
            }
        },
        /**
         * Sets the local filters as url query parameters.
         */
        setFiltersAsQueryParameters() {
            setQueryParameters('task.index', this.filters);
        },
        removeUrlQueryParameters() {
            let query_parameters = router.currentRoute.value.query;
            let new_query = {};
            for (let i in query_parameters) {
                if (i !== 'createTask') {
                    new_query[i] = query_parameters[i];
                }
            }

            router.push({
                name: 'task.index',
                query: new_query
            });
        },
        search() {
            this.timers.search = withTimeout(async () => {
                this.filters.page = 1;
                await this.doSearch();
            }, this.timers.search, 250);
        },
        async pageChanged(page) {
            this.filters.page = page;
            await this.doSearch();
        },
        async loadAvailableRoles() {
            let roles = await getRoles();

            if (!roles.meta) {
                this.availableRoles = Object.values(roles).map((role) => {
                    return {id: role.id, text: this.formatRoleName(role.name)};
                });
            }
        },
        async loadAvailableUsers() {
            let users = await getUsers();

            if (!users.meta) {
                this.availableUsers = Object.values(users).map((user) => {
                    return {id: user.id, text: this.formatRoleName(user.name)};
                });
            }
        },
        async loadAvailableClients() {
            let clients = await getAllClientsWithoutPagination();

            if (!clients.meta) {
                this.availableClients = clients;

                this.availableClients = Object.values(clients).map((client) => {
                    return {id: client.id, text: '#' + client.code + ' ' + client.fullName}
                });
            }
        },
        async loadTasks() {
            this.tasks_loading = true;

            let query = filtersToQueryParameters(this.filters);

            this.tasks = await getTasksPaginated(query);

            this.tasks_loading = false;
        },
        addTask() {
            this.modalToShow = 'add-task';
        },
        showTask(task) {
            this.selectedTask = task;
            this.modalToShow = 'task-list-show-modal';
        },
        editTask(task) {
            this.selectedTask = task;
            this.modalToShow = 'edit-task';
        },
        editTaskStatus(task) {
            this.selectedTask = task;
            this.modalToShow = 'task-change-status-modal';
        },
        editTaskUser(task) {
            this.selectedTask = task;
            this.modalToShow = 'task-change-user-modal';
        },
        editTaskTeam(task) {
            this.selectedTask = task;
            this.modalToShow = 'task-change-team-modal';
        },
        deleteTask(task) {
            this.modalToShow = 'task-delete-modal';
            this.selectedTask = task;
        },
        async setResponsibleTask(user_id) {
            try {
                if (!user_id) {
                    this.selectedTask.user_id = null;
                } else {
                    this.selectedTask.user_id = user_id;
                }

                await updateTask(this.selectedTask);

                this.$store.dispatch('app/setToastMessage', 'Tarea asignada');

                await this.loadTasks();

                this.modalToShow = null;
            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Error al asignar la tarea');

                this.modalToShow = null;
            }
        },
        dateToReadable(date) {
            if (!!date) {
                let splitted = date.substr(0, 10).split('-');
                return splitted[2] + '/' + splitted[1] + '/' + splitted[0];
            }
        },
        async setQuickFilters(types, user = [], role = [], author = [], status = [], client = []) {
            this.emptyFilters();

            this.filters = {
                type: types,
                user: user,
                role: role,
                author: author,
                client: client,
                status: status,
                order: 'DESC',
                page: 1,
            };

            this.$refs.multiselectType.updateSelect(types);
            this.$refs.multiselectRole.updateSelect(role);
            this.$refs.multiselectResponsable.updateSelect(user);
            this.$refs.multiselectAutor.updateSelect(author);
            this.$refs.multiselectClients.updateSelect(client);
            this.$refs.multiselectStatus.updateSelect(status);
        },
        showClient(client) {
            this.modalToShow = 'show-expedient-client';
            this.selectedClient = client;
        },
    },
    unmounted() {
        delete window.$;
        delete window.jQuery;
    }
}
</script>

<style>
.bg-warning {
    color: black !important;
}
</style>
